import { CSSProperties } from "react";

export const navigationBar: CSSProperties = {
    display: "flex",
    // backgroundColor: "#E3D1C4",
    //backgroundColor: '#fffcfc',
    height: 50,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "0 30px",
    //borderBottom: "1px solid rgba(128, 128, 128, 0.5)"

}

export const logoImg: CSSProperties = {
    left: 30,
    width: 40,
    height: 40,
}

export const dateText: CSSProperties = {
    display: "flex",
    color: 'black',
    fontSize: 20,
    fontFamily: "Noto Sans JP",
};

export const languageLinks = {
    display: 'flex',
    justifyContent: 'flex-end'
}